import React from "react";
import ReactDOM from "react-dom/client";

// eslint-disable-next-line import/no-extraneous-dependencies
import jQuery from "jquery";
import "bootstrap";

import RootContainer from "./Containers/RootContainer";

import reportWebVitals from "./reportWebVitals";

// eslint-disable-next-line no-multi-assign, no-global-assign
$ = window.$ = window.jQuery = jQuery;

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <RootContainer />
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
